import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthLayout, Field, inputCls, primaryBtn, ErrorText } from "@/components/AuthLayout";
import { GoogleButton } from "@/components/GoogleButton";
import { useAuth } from "@/context/AuthContext";
import { usePrefs } from "@/context/PrefsContext";
import { errMsg } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const { t } = usePrefs();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "", invitation_code: localStorage.getItem("yk_last_code") || "" });
  const [err, setErr] = useState(() => { const b = sessionStorage.getItem("yk_blocked"); if (b) sessionStorage.removeItem("yk_blocked"); return b || ""; });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      const u = await login(form.email, form.password, form.invitation_code);
      if (form.invitation_code) localStorage.setItem("yk_last_code", form.invitation_code.trim().toUpperCase());
      nav(u.role === "institution_admin" ? "/partner" : u.onboarded ? "/dashboard" : "/onboarding");
    } catch (ex) { setErr(errMsg(ex)); } finally { setBusy(false); }
  };

  return (
    <AuthLayout title={t("login")} subtitle={t("tagline")} footer={<>{t("noAccount")} <Link data-testid="login-register-link" to="/register" className="inline-block py-2 font-medium text-foreground underline-offset-4 hover:underline">{t("register")}</Link></>}>
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <Field label={t("email")} id="email"><input id="email" data-testid="login-email-input" type="email" required className={inputCls} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} autoComplete="email" /></Field>
        <Field label={t("password")} id="password"><input id="password" data-testid="login-password-input" type="password" required className={inputCls} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} autoComplete="current-password" /></Field>
        <ErrorText msg={err} id="login-error" />
        <Field label={t("invCodeLogin")} id="login-code"><input id="login-code" data-testid="login-code-input" className={`${inputCls} uppercase tracking-widest`} value={form.invitation_code} onChange={(e) => setForm({ ...form, invitation_code: e.target.value })} placeholder={t("invCodePh")} autoComplete="off" /></Field>
        <button data-testid="login-submit-button" type="submit" disabled={busy} className={primaryBtn}>{t("login")}</button>
        <div className="text-right"><Link data-testid="login-forgot-link" to="/reset-password" className="inline-flex min-h-[40px] items-center text-xs text-muted-foreground underline-offset-4 hover:underline">{t("forgot")}</Link></div>
      </form>
      <GoogleButton code={form.invitation_code} />
    </AuthLayout>
  );
}
